import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  flex-grow: 1;
  padding: 16px 0;
  background-color: ${({ theme }) => theme.colors.grey100};
  border: 5px solid ${({ theme }) => theme.colors.white};
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 1fr 1fr 1fr;
  gap: 16px;
  padding: 0 24px;
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 2px 4px ${({ theme }) => theme.colors.shadow};
  cursor: pointer;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.greenDark};
  }

  ${({ selected, theme }) =>
    selected &&
    `
    border: 1px solid ${theme.colors.greenDark};
  `}
`;

export const CompanyTitle = styled(typography.TitleOneBoldTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const CompanyInfoWrapper = styled.div`
  display: flex;

  & > * + * {
    margin-inline-start: 50px !important;
  }
`;

export const CompanyInfoSection = styled.div``;

export const CompanyInfoText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;
